// colorPalette.js
// -----------------------------------------------------------------------------
// JavaScript equivalent of the Swift `FFColorPalette`.
// Provides typed color palettes for light / dark mode with optional auto‑detection.
// -----------------------------------------------------------------------------

// const palettes = {
//     light: {
//       text: '#000000', // black
//       button: '#4582B5', // rgb(69,130,181)
//       background: '#F0F0F5', // rgb(240,240,245)
//       container: '#F2FAFF', // rgb(242,250,255)
//       highlight: 'rgba(189,224,255,0.3)', // rgba(0.74,0.88,1.0,0.3)
//       borderSilver: '#BFBFBF',
//       lightRed: '#FFCCCC',
//       shadow: 'rgba(0,0,0,0.15)',
//       progressBarBg: 'rgba(128,128,128,0.2)',
//       progressBarFg: '#3BB24A' // rgb(59,178,74)
//     },
//     dark: {
//       text: '#FFFFFF', // white
//       button: '#59A6E6', // rgb(89,166,230)
//       background: '#1F1F24', // rgb(31,31,36)
//       container: '#292E38', // rgb(41,46,56)
//       highlight: 'rgba(89,166,230,0.2)', // rgba(0.35,0.65,0.90,0.2)
//       borderSilver: '#BFBFBF',
//       lightRed: '#FFCCCC',
//       shadow: 'rgba(0,0,0,0.45)',
//       progressBarBg: 'rgba(128,128,128,0.15)',
//       progressBarFg: '#52D961' // rgb(82,217,97)
//     }
//   };
  
//   /**
//    * Returns a color palette object based on the desired mode.
//    *
//    * @param {('light'|'dark'|'auto')} mode –
//    *   'light' to force light mode,
//    *   'dark'  to force dark mode,
//    *   'auto'  (default) to follow the user's OS preference.
//    * @returns {{[key:string]: string}} Color mapping.
//    */
//   export function getPalette(mode = 'dark') {
//     let isDark;
  
//     if (mode === 'auto') {
//       isDark = typeof window !== 'undefined' &&
//                window.matchMedia &&
//                window.matchMedia('(prefers-color-scheme: dark)').matches;
//     } else {
//       isDark = mode === 'dark';
//     }
  
//     return isDark ? palettes.dark : palettes.light;
//   }
  
//   // Convenience: export the palette determined at import‑time.
//   export const palette = getPalette();
  
//   export default getPalette;
  


// // 1. Define the palette data
// const palettes = {
//   light: {
//     background: '#FFFFFF',
//     container: '#FFFFFF',
//     text: '#000000',
//     textMuted: '#666666',
//     border: '#E0E0E0',
//     shadow: 'rgba(0,0,0,0.1)',
//     highlight: '#F5F5F5',
//     accent: '#007BFF',
//     progressBarFg: '#007BFF',
//     ctaPrimary: '#007BFF',
//     tagAccent: '#007B55', 
//   },
//   dark: {
//     // --- UPDATED DARK MODE COLORS ---
//     background: '#1C212A',      // Deep charcoal/navy
//     container: '#28303E',       // Lighter shade for depth
//     text: '#F8F9FA',            // Bright white-grey
//     textMuted: '#AAB8C2',       // Soft slate gray
//     border: '#3F4756',          // Subtle blue-gray
//     shadow: 'rgba(0, 0, 0, 0.4)',
//     highlight: '#3F4756',       
    
//     // Legacy support
//     accent: '#20A8D8',          
//     progressBarFg: '#20A8D8',   

//     // NEW additions
//     ctaPrimary: '#20A8D8',      
//     tagAccent: '#00DDAA',       
//   },
// };

// // 2. Define the helper function
// const getPalette = (mode = 'dark') => {
//   return palettes[mode] || palettes.dark;
// };

// // 3. EXPORTS

// // Fix for: import { getPalette } from ...
// export { getPalette };

// // Fix for: import { palette } from ... (Exporting dark palette directly for legacy files)
// export const palette = palettes.dark;

// // Fix for: import getPalette from ... (Default export)
// export default getPalette;

// ColorPalette.js
// Synced with Flutter ff_colors.dart

const palettes = {
  light: {
    background: '#FFFFFF',
    container: '#FFFFFF',
    text: '#000000',
    textMuted: '#666666',
    border: '#E0E0E0',
    shadow: 'rgba(0,0,0,0.1)',
    highlight: '#F5F5F5',
    accent: '#1479FF',
    progressBarFg: '#52D961',
    ctaPrimary: '#1479FF',
    tagAccent: '#FFA726',
  },
  dark: {
    background: '#1F1F24',
    container: '#292E38',
    text: '#FFFFFF',
    textMuted: '#A0A8B8',
    textDim: '#6B7280',
    border: '#3A3F4C',
    borderLight: '#484E5C',
    shadow: 'rgba(0, 0, 0, 0.45)',
    highlight: '#232833',

    accent: '#1479FF',
    progressBarFg: '#52D961',
    ctaPrimary: '#1479FF',
    tagAccent: '#FFA726',

    // Additional named colors from app
    accentOrange: '#FFA726',
    accentBlue: '#1479FF',
    green: '#52D961',
  },
};

const getPalette = (mode = 'dark') => {
  return palettes[mode] || palettes.dark;
};

export { getPalette };
export const palette = palettes.dark;
export default getPalette;